import React, { useState, useRef } from "react";

const Input = ({ id, validationClassName = "", className = "", icon = "", ...props }) => {
  const [validationClass, setValidationClass] = useState(validationClassName);
  const [showPassword, setShowPassword] = useState(false);
  const refWrapper = useRef();

  //Remove warning or error border color on focus
  const onFocus = () => {
    if (validationClassName === "error" || validationClassName === "warning") setValidationClass("");
  };

  return (
    <div
      className={validationClass ? `input ${validationClass} ${className}` : `input ${className}`}
      ref={refWrapper}
      id={`wrapper-${id}`}>
      {icon && <div className="icon">{icon}</div>}
      <input id={id} {...props} type={showPassword ? "text" : props.type || "text"} onFocus={onFocus} />
      {props.type === "password" && (
        <div className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
          <img
            src={`${process.env.PUBLIC_URL}/icon/${showPassword ? "eyeOpen" : "eyeClose"}.png`}
            alt={showPassword ? "Hide Password" : "Show Password"}
            style={{ width: "16px", height: "16px" }}
          />
        </div>
      )}
    </div>
  );
};

export default Input;
